$(document).ready(function (e) {
    window.addEventListener('resize', () => {
        document.querySelector(':root').style
            .setProperty('--vh', window.innerHeight / 100 + 'px');
    })
    document.querySelector(':root').style
        .setProperty('--vh', window.innerHeight / 100 + 'px');
});


// pc상단메뉴
$('.shop,.multi-shop').mouseover(function (event) {
    $(this).find('.sub-category').addClass('on');
    $(this).addClass('on');
});

$('.header_center ul li').mouseover(function (event) {

    if ($(this).hasClass('shop')) {

    } else {
        $(this).siblings('.shop').find('.sub-category').removeClass('on');
        $(this).siblings('.shop').removeClass('on');
    }
});


$('.multi-shop').mouseout(function (event) {
    $(this).find('.sub-category').removeClass('on');
    $(this).removeClass('on');
});

// ip check 
$.getJSON('https://api.db-ip.com/v2/free/self', function(data) {
  let country_code = data["countryCode"];
  let is_wechat = $('body').attr('id')
  if (country_code == "CN" && is_wechat != "wechat"){
    alert("Please visit to wechat store")
    location.href = "pages/wechat";
    fetch('/cart/clear.js', {method: 'POST'})
  }
  console.log(country_code);
});


$(document).ready(function () {
  window.localStorage.removeItem('draft');
})

// 리디렉션
$('.goto-kr').click(function () {

    var pathname = $(location).attr('pathname');
    var kr = 'https://thisisneverthat.com'

    $(location).attr('href', kr + pathname + '?no_rule=true')
});

$('.goto-en').click(function () {
  
    var pathname = $(location).attr('pathname');
    var intl = 'https://intl.thisisneverthat.com'
    
    $(location).attr('href', intl + pathname + '?no_rule=true')
});

$('.goto-jp').click(function () {

    var pathname = $(location).attr('pathname');
    var intl = 'https://thisisneverthat.jp'

    $(location).attr('href', intl + pathname + '?no_rule=true')
});


// 리디렉션 모바일
$('.multi-mo').change(function () {

    var urlchange = $(".multi-mo option:selected").val();
    var pathname = $(location).attr('pathname');

    $(location).attr('href', urlchange + pathname + '?no_rule=true')
});

$(function () {
    var mult_width = $('.header_right').width() + 80
    $('.multi-shop .sub-category').css({
        'width': mult_width
    });
});


$('.sub-category').mouseleave(function (event) {
    $(this).removeClass('on');
    $(this).parent('.shop').removeClass('on');
});


$('.shop .sub-category .site-nav li,.multi-shop .sub-category .site-nav li').mouseenter(function (event) {
    $(this).addClass('on');
});
$('.shop .sub-category .site-nav li,.multi-shop .sub-category .site-nav li').mouseleave(function (event) {
    $(this).removeClass('on');
});
$('.site-nav .has_child').mouseenter(function (event) {
    $(this).find('.child_menu').addClass('on');
});
$('.site-nav .has_child').mouseleave(function (event) {
    $(this).find('.child_menu').removeClass('on');
});
$('.mo_menu .has_child > a').click(function (event) {
    $(this).find('.arrow_right').toggleClass('on');
    $(this).siblings('.child_menu').toggleClass('on');
});

$('.search').click(function (event) {
    $('.search_wrap').toggleClass('on');
    $('.modal').toggleClass('visible');
    //   $('html').toggleClass('open');
    $(this).toggleClass('on');
    $('body').removeClass('ajaxify-modal--visible');
    $('.ajaxify-modal').removeClass('is-visible');

    setTimeout(function () {
        $('.search_focus').focus();

    }, 100);
});


$('.search_close').click(function (event) {
    $('.search_wrap').removeClass('on');
  	$('.header_center ul li.search ').removeClass('on');
    $('.modal ').removeClass('visible');
});



$('.close_icon').click(function (event) {
    $('.search_wrap').removeClass('on');
    $('.modal').removeClass('visible');
    $('html').removeClass('open');
});

$('.modal').click(function (event) {
    $('.search_wrap').removeClass('on');
    $('.search').removeClass('on');
    $('.newsletter_wrap').removeClass('on');
    $('.modal').removeClass('visible');
    $('html').removeClass('open');
    $('.coll_btn_wrap').find('div').removeClass('on');
    $('.size-guide').removeClass('on');
    $('#submit_form').removeClass('on')
    $('.prd_shipping').removeClass('on');
    $('.video-wrapper').fadeOut();
});

$('.filter_modal').click(function (event) {
    $(this).removeClass('visible');
    $('.coll_btn_wrap').find('div').removeClass('on');
});

$('#addToCart-product-template').click(function () {
    $('#shopify-section-header').removeClass('nav-up');
    $('.breadcrumb').removeClass('on');

});

$(window).resize(function () {
    if ($(window).width() > 1140) {

        setTimeout(function () {

            $('#ajaxifyModal').mouseover(function () {
                $('html').addClass('open');
            });
          
            $('#ajaxifyModal').mouseleave(function () {
                $('html').removeClass('open');
            });

        }, 100);
    }
});



// 모바일 햄버거메뉴
$('#hb_bt').click(function (event) {
    $(this).toggleClass('open');
    $('.mo_menu').toggleClass('on');

    $(this).addClass('on');
    $('#ajaxifyModal').removeClass('is-visible');
    $('html').removeClass('open');
    $('body').removeClass('ajaxify-modal--visible');

    if ($('.mo_menu').hasClass('on')) {
        $('.mo_header').addClass('on');
        $('html').addClass('open')
    } else {
        $('.mo_header').removeClass('on');
        $('html').removeClass('open')
    }
});


// 모바일 메뉴
$('.mshop_bt').click(function () {
    $(this).siblings('.menu_shop').toggleClass('on');
    $(this).toggleClass('on');
});


$('.menu_wrap .site-header__search').click(function () {
    $('#hb_bt').removeClass('on');
    $('#hb_bt').removeClass('open');
    $('.mo_menu').removeClass('on');
    $('html').removeClass('open');
});


$('.cart_bt').click(function (event) {
    $('body').removeClass('open');
    $('#hb_bt').removeClass('on');
    $('#hb_bt').removeClass('open');
    $('.mo_menu').removeClass('on');
    $('.menu-trigger').removeClass('on');
    $(this).toggleClass('on');
    $('.modal').removeClass('visible');
});


// 뉴스레터
$('.newsletter_bt').click(function (event) {
    $('.newsletter_wrap').addClass('on');
    $('.modal').addClass('visible');
    $('html').addClass('open');
});

$('.newsletter_close').click(function (event) {
    $('.newsletter_wrap').removeClass('on');
    $('.modal').removeClass('visible');
    $('html').removeClass('open');
});



// 메뉴높이에 따른 content top
function mediaSize() {
    setInterval(function () {

        var header_height = $('#shopify-section-header').height();
        var header_height2 = $('#shopify-section-header').height() * 0.85 + 7.5;
        var cart_box = $('.ajaxifyCart--content').height() - $('.cart_subtotal').height()
        var box = header_height2 + $('.cart_subtotal').height() + 40

        $('.ajaxify-modal').css({
            'height': 'calc(100% - ' + header_height2 + 'px)'
        });

        $('.main-content').css('padding-top', $('#shopify-section-header').height() + 'px');

        $('.ajaxify-modal').css('top', header_height * 0.85 + 'px');

        $('#ajaxifyCart-overlay').css('top', header_height + 'px');

        $('.menu_wrap').css({
            'height': 'calc(100 * var(--vh) - ' + header_height + 'px)'
        });

        $('.ajaxify-modal .cart_box').css({
            'height': 'calc(100 * var(--vh) - ' + box + 'px)'
        });

        $('.cart_close').click(function () {
            $('.ajaxify-modal').removeClass('is-visible');
            $('html').removeClass('open');
            $('body').removeClass('ajaxify-modal--visible');
        });

        $('.section-header').css('top', header_height + 'px');
        $('.breadcrumb').css('top', header_height + 'px');
        $('.lb_prd_wrap').css('height', $('.lb_img').height() + 'px');
        $('.search_wrap').css('top', header_height + 'px');
        $('.sub-category').css('top', header_height + 'px');
        $('.sub-category').css({
            'height': 'calc(100% - ' + header_height + 'px)'
        });

        $('.mo_menu.on').css('padding-top', header_height + 'px');

    }, 0);
};
mediaSize();
window.addEventListener('resize', mediaSize, false);

// 상단 스크롤
jQuery(document).ready(function ($) {

    var mainHeader = $('#shopify-section-header'),
        secondaryNavigation = $('.cd-secondary-nav'),
        //this applies only if secondary nav is below intro section
        belowNavHeroContent = $('.sub-nav-hero'),
        headerHeight = mainHeader.height();

    //set scrolling variables
    var scrolling = false,
        previousTop = 0,
        currentTop = 0,
        scrollDelta = 10,
        scrollOffset = 150;


    $(window).on('scroll', function () {
        if (!scrolling) {
            scrolling = true;
            (!window.requestAnimationFrame) ?
            setTimeout(autoHideHeader, 250): requestAnimationFrame(autoHideHeader);
        }
    });

    $(window).on('resize', function () {
        headerHeight = mainHeader.height();
    });

    function autoHideHeader() {
        var currentTop = $(window).scrollTop();

        (belowNavHeroContent.length > 0) ?
        checkStickyNavigation(currentTop) // secondary navigation below intro
            : checkSimpleNavigation(currentTop);

        previousTop = currentTop;
        scrolling = false;
    }

    function checkSimpleNavigation(currentTop) {
        //there's no secondary nav or secondary nav is below primary nav

        if (previousTop - currentTop > scrollDelta) {
            //if scrolling up...
            mainHeader.removeClass('nav-up');
            $('.section-header').removeClass('on');
            $('.breadcrumb').removeClass('on');



        } else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
            //if scrolling down...
            mainHeader.addClass('nav-up');
            $('.section-header').addClass('on');
            $('.breadcrumb').addClass('on');
            $('#ajaxifyModal').removeClass('is-visible');
            $('body').removeClass('ajaxify-modal--visible');
            $('.search_wrap').removeClass('on')

            $('.snize-ac-results').fadeOut()

            $('.modal').removeClass('visible');

            $('.mo_menu').removeClass('on')
            $('#hb_bt').removeClass('open')

            $('html').removeClass('open')
            $('.size-guide').removeClass('on')
            $('#submit_form').removeClass('on')
            $('.prd_shipping').removeClass('on')

        }
    }
});



// 메인
$('.mbanner_close').click(function () {
    $('.main_banner').addClass('on');
})


// 스크롤이 div 위치에 왔을 때
// $(window).scroll(function() {
// 	var scroll = $(window).scrollTop();
// 	//console.log(scroll);
// 	if (scroll >= $('.main03').offset().top) {
// 		console.log('a');
//       $('.main03').addClass('on');
// 	} else {
// 		console.log('b');
// 	}
// });

// 스크롤시 추가 fadein, sub_text fadein
//     $('.main_inner ul li').each(function (index, item) { 
//         $(this).addClass('main_' + index);
//         $(window).scroll(function(){
//             if($(window).scrollTop() > (($('.main_' + index).offset().top) - 350) && $(window).scrollTop() < ($('.main_' + index).offset().top + $('.main_' + index).height() - 350)){
//                 $('.main_' + index).addClass('on');
//                 // $('.sirv_list' + index).next().fadeIn(1000);
//             }else{
//                 $('.main_' + index).removeClass('on');
//             };
//         });
//     });



// 상품 리스트
function sort() {
  console.log(window.location.host);
  console.log(window.location.pathname);
    $('.sort h4.t1').attr('data-state', '1');
    var host = window.location.host,
        path = window.location.pathname,
        search = window.location.search,
        url = host + path,
        f1 = 'https://' + url + '?sort_by=price-ascending',
        f2 = 'https://' + url + '?sort_by=price-descending',
        f3 = 'https://' + url + '?sort_by=created-descending',
        f4 = 'https://' + url + '?sort_by=best-selling';

  if (search) {
    url = host + path + search,
        f1 = 'https://' + url + '&sort_by=price-ascending',
        f2 = 'https://' + url + '&sort_by=price-descending',
        f3 = 'https://' + url + '&sort_by=created-descending',
        f4 = 'https://' + url + '&sort_by=best-selling';
  }

    $('#f1').attr('href', f1);
    $('#f2').attr('href', f2);
    $('#f3').attr('href', f3);
    $('#f4').attr('href', f4);
};

$().ready(function () {
    sort();
});

if (window.location.href.indexOf("price-ascending") > -1) {
    $('#f1').find('.check_box').addClass('on');
    $('#f3').find('.check_box').removeClass('on');
} else if (window.location.href.indexOf("price-descending") > -1) {
    $('#f2').find('.check_box').addClass('on');
    $('#f3').find('.check_box').removeClass('on');
} else if (window.location.href.indexOf("created-descending") > -1) {
    $('#f3').find('.check_box').addClass('on');
} else if (window.location.href.indexOf("best-selling") > -1) {
    $('#f4').find('.check_box').addClass('on');
    $('#f3').find('.check_box').removeClass('on');
};

if ($('.coll_nav.tag').text().indexOf('ArchiveTop') >= 0) {
    $('.coll_nav_now.tag a').text('Tops')
} else if ($('.coll_nav.tag').text().indexOf('ArchiveBottom') >= 0) {
    $('.coll_nav_now.tag a').text('Bottoms')
} else if ($('.coll_nav.tag').text().indexOf('ArchiveAccessory') >= 0) {
    $('.coll_nav_now.tag a').text('Accessories ')
}


$('.sort_bt').click(function (event) {
    $('.sort').toggleClass('on');
    $(this).toggleClass('on');
    $(this).siblings('.coll_btn').removeClass('on');
    $('.view').removeClass('on');
    $('.pt-container').removeClass('on');

    if ($(this).hasClass('on')) {
        $('.filter_modal').addClass('visible');
    } else {
        $('.filter_modal').removeClass('visible');
    }
});

$('.sort_close').click(function (event) {
    $('.sort').removeClass('on');
    $('.sort_bt').removeClass('on');
    $('.filter_modal').removeClass('visible');
});

$('.view_bt').click(function (event) {
    $('.view').toggleClass('on');
    $(this).toggleClass('on');
    $(this).siblings('.coll_btn').removeClass('on');
    $('.sort').removeClass('on');
    $('.pt-container').removeClass('on');

    if ($(this).hasClass('on')) {
        $('.filter_modal').addClass('visible');
    } else {
        $('.filter_modal').removeClass('visible');
    }
});

$('.view_close').click(function (event) {
    $('.view').removeClass('on');
    $('.view_bt').removeClass('on');
    $('.filter_modal').removeClass('visible');
});


// 클릭시 필터메뉴 사라지게
$('#shopify-section-header,.prd_list_wrap,.section-header--left,.pagination,footer ').click(function () {
    $('.coll_btn_wrap').find('div').removeClass('on');
});


// 상품상세 detail
$(document).ready(function () {

    var color = $("#productSelect-product-template-option-0 option:selected").val()

    $('.detail_des_wrap h1.h2').append('&nbsp<span class="color_name"></span>')
    $('.color_name').text(color);
    $(".detail_des_wrap").attr('data-color', color);

    $('#productSelect-product-template-option-0').change(function () {
        var color = $("#productSelect-product-template-option-0 option:selected").val()
        $('.color_name').text(color);
        $(".detail_des_wrap").attr('data-color', color);
    });

    setTimeout(function () {
        var thumb_length = $('.thumbnails-slider .slick-slide').length;
        if (thumb_length < 7) {
            $('.thumbnails-slider').addClass('on')
        }
        console.log(thumb_length)
    }, 600)


    $('.big_detail a').each(function (index, item) {
        $(this).addClass('big' + index);
    });

    $('.main-image-slider').on('click', '.slick-slide', function () {
        $('.big_detail_wrap').addClass('on');
        $('html').addClass('open');

        var big = 'big' + $(this).attr('data-slick-index')
        var spare2 = $(window).height() - $('.big_detail').find('.' + big).height()
        var spare = spare2 / 2
        var scroll = $('.big_detail').find('.' + big).offset().top - spare

        $('.big_detail_wrap').scrollTop(scroll);
    });

    $('.big_detail_wrap').click(function () {

        $(this).removeClass('on');
        $('html').removeClass('open');
        $('.big_detail_wrap').scrollTop(0);
    });


    /*********************
          Thumbnails slider
        *********************/
    // Change the main image whenever a thumbnail button is activated
    $('.thumbnails-slider').on('init', function (e, slider) {
        $(slider.$slides.find('.thumbnail-button')).each(function (index) {
            $(this).on('click', function () {

                // Move aria-current="true" to this button
                $(slider.$slides.find('.thumbnail-button').removeAttr('aria-current'));
                $(this).attr('aria-current', true);

                // Change the main image to match this thumbnail button
                var index = $(this).closest('.slick-slide').data('slick-index');
                $('.main-image-slider').slick('slickGoTo', index);

                $('.main-image-slider').slick('slickGoTo', index);
            });

            $('.slick-cloned').click(function () {

                var index2 = $(this).closest('.slick-cloned').data('slick-index');

                $('.main-image-slider').slick('slickGoTo', index2);
            })
        });
    });


    // product 이미지 정렬 코드로 수정
    setTimeout(function () {
        //console.log(variant_media_list);
        if (typeof variant_media_list !== 'undefined') {
            okasVariantImageAutomator($('[name="id"]').val());
        }
    }, 500);
  
    $('.swatch-element [data-media-id]').change(function () {
        setTimeout(function () {
            var selected_variant_id = $('[name="id"]').val();
            okasVariantImageAutomator(selected_variant_id);
        }, 100);
    });

    function okasVariantImageAutomator(variant_id) {
        if (typeof variant_media_list !== 'undefined') {
            var selected_variant_id = variant_id;
            var img_new_slides = '';
            var thumb_new_slides = '';
            var big_img_slides = '';
            for (m in variant_media_list[selected_variant_id]) {
                media_key = Object.keys(variant_media_list[selected_variant_id][m])[0];

                //media_img = variant_media_list[selected_variant_id][m][media_key];
                //img_new_slides += '<a class="image-link product-photo-thumb product-photo-thumb-product-template" data-media-id="'+media_key+'">'+
                //'<img class="lazyload no-js" src="'+media_img+'">'+
                //'</a>';

                if ($('#multi-variant-info [data-media-id="' + media_key + '"]').hasClass('product_video ')) {
                    img_new_slides += '<div class="' + $('#multi-variant-info [data-media-id="' + media_key + '"]').attr('class') + '" data-media-id="' + media_key + '">' +
                        $('#multi-variant-info [data-media-id="' + media_key + '"]').html() +
                        '</div>';
                } else {
                    img_new_slides += '<a class="' + $('#multi-variant-info [data-media-id="' + media_key + '"]').attr('class') + '" data-media-id="' + media_key + '">' +
                        $('#multi-variant-info [data-media-id="' + media_key + '"]').html() +
                        '</a>';
                }


                //thumb_new_slides += '<button class="thumbnail-button" aria-current="true">'+
                //  '<a class="product-photo-thumb product-photo-thumb-product-template" data-media-id="'+media_key+'">'+
                //    '<img src="'+media_img.replace('_700x', '_80x80')+'" alt="" class="product-single__thumbnail-image" />'+
                //  '</a>'+
                //'</button>';
                if ($('#multi-variant-thumb [data-media-id="' + media_key + '"]').hasClass('product_video')) {
                    thumb_new_slides += '<button class="thumbnail-button" aria-current="true">' +
                        '<div class="' + $('#multi-variant-thumb [data-media-id="' + media_key + '"]').attr('class') + '" data-media-id="' + media_key + '">' +
                        $('#multi-variant-thumb [data-media-id="' + media_key + '"]').html() +
                        '</div>' +
                        '</button>';
                } else {
                    thumb_new_slides += '<button class="thumbnail-button" aria-current="true">' +
                        '<a class="product-photo-thumb product-photo-thumb-product-template" data-media-id="' + media_key + '">' +
                        $('#multi-variant-thumb a[data-media-id="' + media_key + '"]').html() +
                        '</a>' +
                        '</button>';
                }

                big_img_slides += '<a data-image-id="' + media_key + '" class="big' + m + '">' +
                    $('#multi-variant-popup a[data-image-id="' + media_key + '"]').html() +
                    '</a>';
            }
            $('.main-image-slider').slick('unslick');
            $('.thumbnails-slider').slick('unslick');
            $('.main-image-slider').html(img_new_slides);
            $('.thumbnails-slider').html(thumb_new_slides);

            $('.big_detail_wrap .big_detail').html(big_img_slides);

            $('.thumbnails-slider').slick({
                vertical: true,
                slidesToShow: 6,
                lazyLoad: 'ondemand',
                cssEase: 'cubic-bezier(0.4,1,0.4,1)',
                speed: 400,
                arrows: false,
                asNavFor: '.main-image-slider',
            });
            $('.main-image-slider').slick({
                lazyLoad: 'ondemand',
                slidesToShow: 1,
                draggable: true,
                dots: true,
                lazyLoad: false,
                cssEase: 'cubic-bezier(0.4,1,0.4,1)',
                speed: 400,
                responsive: [{
                    breakpoint: 1140,
                    settings: {
                        arrows: false,
                    }
                }]
            });
        }
    }
    //


    // Initialize the slider
    $('.thumbnails-slider').slick({
        vertical: true,
        slidesToShow: 6,
        cssEase: 'cubic-bezier(0.4,1,0.4,1)',
        speed: 400,
        arrows: false,
        asNavFor: '.main-image-slider',
    });


    /********************
          Main image slider
        *********************/
    $('.main-image-slider').slick({
        slidesToShow: 1,
        draggable: true,
        dots: true,
        lazyLoad: false,
        cssEase: 'cubic-bezier(0.4,1,0.4,1)',
        speed: 400,
        responsive: [{
            breakpoint: 1140,
            settings: {
                arrows: false,
            }
        }]
    });


    // Update the thumbnail slider when the user changes the main slider directly.
    $('.main-image-slider').on('beforeChange', function (e, slider, currentSlide, nextSlide) {
        // Remove aria-current from the last selected thumbnail image button
        $('.thumbnails-slider .thumbnail-button[aria-current="true"]').removeAttr('aria-current');

        // Select the thumbnail image button that goes with this main image. Most importantly, this updates Slick's internal state to be consistent with the visual change.
        $('.thumbnails-slider').slick('slickGoTo', nextSlide);

        // Add aria-current="true" to the correct thumbnail image button to convey to screen readers that it's active.
        $('.thumbnails-slider .thumbnail-button:eq(' + nextSlide + ')').attr('aria-current', true);
    });


    var $slider = $('.main-image-slider');

    if ($slider.length) {
        var currentSlide;
        var slidesCount;
        var sliderCounter = document.createElement('div');
        sliderCounter.classList.add('slider__counter');

        var updateSliderCounter = function (slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            $(sliderCounter).text(currentSlide + ' / ' + slidesCount)
        };

        $slider.on('init', function (event, slick) {
            $slider.append(sliderCounter);
            updateSliderCounter(slick);
        });

        $slider.on('afterChange', function (event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });

        //         $slider.slick();
    }
});

// 상세 비메오 시작/일시정지
$(document).ready(function () {
    $('.main-image-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {

        var dsdsdsd = $(this).closest('.main-image-slider').find('.slick-current.slick-active iframe').hasClass('youtube_video');
        var test = $(this).closest('.main-image-slider').find('.slick-slide iframe').hasClass('youtube_video');

        if (test) {

            if (dsdsdsd) {
                var iframe = $('.slick-current.slick-active .youtube_video')[0];
                var player = $f(iframe);
                player.api('play');
            } else {
                var iframe = $(this).closest('.main-image-slider').find('.youtube_video')[0];
                var player = $f(iframe);
                player.api('pause');
            }
        }
    });
});



// var model_size = $('.model_size').text()
var style_img = $('.product-description .style_img img').attr("src")
var style_view = $('.product-description .style_img .style_view a').attr("href")
var style_view_txt = $('.product-description .style_img .style_view a').text()

$('.product-description .model_size').hide();


setTimeout(function () {
    // $('.des_bt_wrap .model_size_show').text(model_size)
    // $('.size-guide .model_size_show').text(model_size)

    $('#hts .style_img_show img').attr("src", style_img);
    $('#hts .style_view_show a').attr("href", style_view);
    $('#hts .style_view_show a').text(style_view_txt);
}, 200);


$('.sg_bt').click(function (event) {
    $('.size-guide').toggleClass('on');
    $('.modal').toggleClass('visible');
    $('html').toggleClass('open');
});

$('.sr_bt').click(function (event) {
    $('.prd_shipping').toggleClass('on');
    $('.modal').toggleClass('visible');
    $('html').toggleClass('open');
});

$('.shipping_close').click(function (event) {
    $('.prd_shipping').removeClass('on');
    $('.modal').removeClass('visible');
    $('html').removeClass('open');
});



// 사이즈차트
$('.by-cm').each(function (i) {

    var i_cm = $(this).text(),
        i_in = (i_cm / 2.54).toFixed(1);

    //   if ($(this).find('.by-cm').length) {
    //     $(this).append('<span class="by-inc">' + i_in + '</span>');
    //   }

    if ($(this).length) {
        $(this).after('<span class="by-inc">' + i_in + '</span>');
    }
});


// $('.size-guide').append('<div class="prefer"><a id="by-cm" class="sltd">CENTIMETERS</a> / <a id="by-inc">INCHES</a></div>');
// $('.size-guide').append('<span class="model_size_show"></span>');
$('.sizing').prepend('<div class="size_close"><span>CLOSE</span></div>');


$('.prefer a').click(function (e) {
    $('.size-guide > .size-detail-wrap > .size-detail .sd1 div span').hide();
    $('.size-guide > .size-detail-wrap > .size-detail .sd1 td span').hide();
    $('.prefer a').removeClass('sltd');
    if (this.id === 'by-cm') {
        $(this).addClass('sltd');
        $('.size-guide > .size-detail-wrap > .size-detail .sd1 div span.by-cm').show();
        $('.size-guide > .size-detail-wrap > .size-detail .sd1 td span.by-cm').show();
    } else if (this.id === 'by-inc') {
        $(this).addClass('sltd');
        $('.size-guide > .size-detail-wrap > .size-detail .sd1 div span.by-inc').show();
        $('.size-guide > .size-detail-wrap > .size-detail .sd1 td span.by-inc').show();
    }
    e.preventDefault();
});

$('.prefer a').click(function (e) {
    $('.size-guide > .size-detail .sd1 div span').hide();
    $('.size-guide > .size-detail .sd1 td span').hide();
    $('.prefer a').removeClass('sltd');
    if (this.id === 'by-cm') {
        $(this).addClass('sltd');
        $('.size-guide > .size-detail .sd1 div span.by-cm').show();
        $('.size-guide > .size-detail .sd1 td span.by-cm').show();
    } else if (this.id === 'by-inc') {
        $(this).addClass('sltd');
        $('.size-guide > .size-detail .sd1 div span.by-inc').show();
        $('.size-guide > .size-detail .sd1 td span.by-inc').show();
    }
    e.preventDefault();
});

$('.size_close').click(function (event) {
    $('.size-guide').removeClass('on');
    $('.modal').removeClass('visible');
    $('html').removeClass('open');
});


if ($('.grid-item').find('div').hasClass('size-guide')) {
    $('.sg_bt').show();
} else {
    $('.sg_bt').hide();
};


//cross-sell
setInterval(function () {

    if ($('#cross-sells').hasClass('cross-sell')) {
        $('#hts').show();
    } else {
        $('#hts').hide();
    };
});


$(document).ready(function () {

    if ($('.product-description .prd_cross').children('div').hasClass('prd_cross_1')) {

        setTimeout(function () {
            $('#cross-sells').append('<div class="xs-card cross_1"><div class="xs-card-body"><div class="xs-image-wrapper"><img  class="xs-image"></div><div class="xs-content"><div class="xs-product-title">tit</div><div class="price">price</div></div></div></div>');

            var cross_tit = $('.product-description .prd_cross_1 .cross_tit').text()
            var cross_price = $('.product-description .prd_cross_1 .cross_price').text()
            var cross_img = $('.product-description .prd_cross_1 img').attr("src")

            $('.cross_1 .xs-product-title').text(cross_tit);
            $('.cross_1 .price').text(cross_price);
            $('.cross_1 .xs-image-wrapper img').attr("src", cross_img);
        }, 1500);
    }

    if ($('.product-description .prd_cross').children('div').hasClass('prd_cross_2')) {

        setTimeout(function () {
            $('#cross-sells').append('<div class="xs-card cross_2"><div class="xs-card-body"><div class="xs-image-wrapper"><img  class="xs-image"></div><div class="xs-content"><div class="xs-product-title">tit</div><div class="price">price</div></div></div></div>');

            var cross_tit = $('.product-description .prd_cross_2 .cross_tit').text()
            var cross_price = $('.product-description .prd_cross_2 .cross_price').text()
            var cross_img = $('.product-description .prd_cross_2 img').attr("src")

            $('.cross_2 .xs-product-title').text(cross_tit);
            $('.cross_2 .price').text(cross_price);
            $('.cross_2 .xs-image-wrapper img').attr("src", cross_img);
        }, 1500);
    }

    if ($('.product-description .prd_cross').children('div').hasClass('prd_cross_3')) {

        setTimeout(function () {
            $('#cross-sells').append('<div class="xs-card cross_3"><div class="xs-card-body"><div class="xs-image-wrapper"><img  class="xs-image"></div><div class="xs-content"><div class="xs-product-title">tit</div><div class="price">price</div></div></div></div>');

            var cross_tit = $('.product-description .prd_cross_3 .cross_tit').text()
            var cross_price = $('.product-description .prd_cross_3 .cross_price').text()
            var cross_img = $('.product-description .prd_cross_3 img').attr("src")

            $('.cross_3 .xs-product-title').text(cross_tit);
            $('.cross_3 .price').text(cross_price);
            $('.cross_3 .xs-image-wrapper img').attr("src", cross_img);
        }, 1500);
    }
})

//How To Style
   $(document).ready(function () {
        if (
            $(".product-description .hts_comingsoon")
                .children("div")
                .hasClass("hts_comingsoon_1")
        ) {
            setTimeout(function () {
                $(".hts_product_list").append(
                    '<a><div class="hts_product comingsoon_1"><div class="hts_product_img_wrap"><img class="hts_product_img"></div><div class="hts_product_text"><div class="hts_product_title"></div><div class="hts_product_price"></div></div></div></a>'
                );

                var hts_title = $(
                    ".product-description .hts_comingsoon_1 .comingsoon_title"
                ).text();
                var hts_price = $(
                    ".product-description .hts_comingsoon_1 .comingsoon_price"
                ).text();
                var hts_img = $(
                    ".product-description .hts_comingsoon_1 img"
                ).attr("src");

                $(".comingsoon_1 .hts_product_title").text(hts_title);
                $(".comingsoon_1 .hts_product_price").text(hts_price);
                $(".comingsoon_1 .hts_product_img").attr("src", hts_img);
            }, 1500);
        }

        if (
            $(".product-description .hts_comingsoon")
                .children("div")
                .hasClass("hts_comingsoon_2")
        ) {
            setTimeout(function () {
                $(".hts_product_list").append(
                    '<a><div class="hts_product comingsoon_2"><div class="hts_product_img_wrap"><img class="hts_product_img"></div><div class="hts_product_text"><div class="hts_product_title"></div><div class="hts_product_price"></div></div></div></a>'
                );

                var hts_title = $(
                    ".product-description .hts_comingsoon_2 .comingsoon_title"
                ).text();
                var hts_price = $(
                    ".product-description .hts_comingsoon_2 .comingsoon_price"
                ).text();
                var hts_img = $(
                    ".product-description .hts_comingsoon_2 img"
                ).attr("src");

                $(".comingsoon_2 .hts_product_title").text(hts_title);
                $(".comingsoon_2 .hts_product_price").text(hts_price);
                $(".comingsoon_2 .hts_product_img").attr("src", hts_img);
            }, 1500);
        }

        if (
            $(".product-description .hts_comingsoon")
                .children("div")
                .hasClass("hts_comingsoon_3")
        ) {
            setTimeout(function () {
                $(".hts_product_list").append(
                    '<a><div class="hts_product comingsoon_1"><div class="hts_product_img_wrap"><img class="hts_product_img"></div><div class="hts_product_text"><div class="hts_product_title"></div><div class="hts_product_price"></div></div></div></a>'
                );

                var hts_title = $(
                    ".product-description .hts_comingsoon_3 .comingsoon_title"
                ).text();
                var hts_price = $(
                    ".product-description .hts_comingsoon_3 .comingsoon_price"
                ).text();
                var hts_img = $(
                    ".product-description .hts_comingsoon_3 img"
                ).attr("src");

                $(".comingsoon_3 .hts_product_title").text(hts_title);
                $(".comingsoon_3 .hts_product_price").text(hts_price);
                $(".comingsoon_3 .hts_product_img").attr("src", hts_img);
            }, 1500);
        }
    });

// preorder
setTimeout(function () {
    $('#pn-modal-close-btn').text('Close')
}, 500)


// 피처스 features
$('.blog_list_img').find('video').removeAttr('autoplay');

$('.blog_list .blog_list_name').mouseenter(function (event) {
    $(this).siblings('.blog_list_img').addClass('on');

    if ($(this).siblings('.blog_list_img').hasClass('on')) {
        $(this).siblings('.blog_list_img').find('video')[0].play();
    } else {
        $(this).siblings('.blog_list_img').find('video')[0].pause();
    }

});

$('.blog_list .blog_list_name').mouseleave(function (event) {
    $(this).siblings('.blog_list_img').removeClass('on');
    $(this).siblings('.blog_list_img').find('video')[0].pause();
});





$(document).mousemove(function (e) {
    $('#features .blog_list .blog_list_img').css("top", e.clientY);
    $('#features .blog_list .blog_list_img').css("left", e.clientX);
});


$(document).on("mousemove", function (event) {

    var height = $(window).height();

    if (event.clientY > height * 0.6) {
        $('#features .blog_list .blog_list_img').addClass('bt')
    } else {
        $('#features .blog_list .blog_list_img').removeClass('bt')
    }
});



// lookbook 룩북
setTimeout(function () {
    var mySwiper = new Swiper('.lookbook_slide', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        grabCursor: true,
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            invert: false,
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
    });
}, 100);


// lookbook_prd
$(function () {
    var mySwiper = new Swiper('.swiper_lb_prd', {
        loop: true,
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            invert: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
    });
});



$('.edit_sp20 img').each(function (index, item) {
    var index = index + 1;
    $(this).addClass('' + index);
});

// about
if (window.location.href.indexOf("contact") > -1) {
    $('.nav_about').addClass('on');
} else if (window.location.href.indexOf("stores") > -1) {
    $('.nav_stores').addClass('on');
} else if (window.location.href.indexOf("stockists") > -1) {
    $('.nav_stockist').addClass('on');
} else if (window.location.href.indexOf("legal") > -1) {
    $('.nav_legal').addClass('on');
    $('.breadcrumb').scrollLeft(200);
} else if (window.location.href.indexOf("terms-conditions") > -1) {
    $('.nav_terms').addClass('on');
    $('.breadcrumb').scrollLeft(350);
} else if (window.location.href.indexOf("privacy-policy") > -1) {
    $('.nav_privacy').addClass('on');
    $('.breadcrumb').scrollLeft(500);
} else if (window.location.href.indexOf("lookbook") > -1) {
    $('.nav_lookbook').addClass('on');
} else if (window.location.href.indexOf("news") > -1) {
    $('.nav_news').addClass('on');
} else if (window.location.href.indexOf("video") > -1) {
    $('.nav_video').addClass('on');
} else if (window.location.href.indexOf("faq") > -1) {
    $('.nav_faq').addClass('on');
};


// store
setTimeout(function () {
    var mySwiper = new Swiper('.store_swiper', {
        grabCursor: true,
        slidesPerView: 'auto',
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            invert: false,
        },
        freeMode: true,
        spaceBetween: 2,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
    });
}, 100);


// video 비디오
if (window.location.href.indexOf("video") > -1) {
    $('.breadcrumb_features').scrollLeft(200);
} else if (window.location.href.indexOf("news") > -1) {
    $('.breadcrumb_features').scrollLeft(100);
}


$('.bottom-wrapper').prepend("<div class=big_title></div>");

$('.video_content').each(function () {

    var text = $(this).find('.video_title').html();

    $(this).find('.big_title').html(text);
});



$('.video_content>video').click(function () {
    $(this).siblings('.video_big').fadeIn();
    $(this).siblings('.video_big').addClass('open');
    $(this).siblings('.video_big').find('video')[0].play();
    $(this).siblings('.video_big').find('.video-controls').addClass('playing');
    $(this).siblings('.video_big').find('.video-controls').delay(4000).fadeOut();

    $('.breadcrumb_features').addClass('video');
    $('.main-content').addClass('video');
    $('#shopify-section-header').addClass('video');
    $('html').addClass('open');
});

$('.video_content>img').click(function () {
    $(this).siblings('.video_big').fadeIn();
    $(this).siblings('.video_big').addClass('open');
    $(this).siblings('.video_big').find('video')[0].play();
    $(this).siblings('.video_big').find('.video-controls').addClass('playing');
    $(this).siblings('.video_big').find('.video-controls').delay(4000).fadeOut();

    $('.breadcrumb_features ').addClass('video');
    $('.main-content').addClass('video');
    $('#shopify-section-header').addClass('video');
    $('html').addClass('open');
});

$('.video_big').each(function () {
    $(this).prepend("<div class=video_close><img src=https://cdn.shopify.com/s/files/1/0562/4971/2815/files/close_eca94136-5b61-4d86-99fe-5da4620b442f.svg?v=1623037598></div>");
});


//close

$('.video_close').click(function () {

    var $video = $(this).siblings('.custom-video-area').find('video')
    var $video_controls = $(this).siblings('.custom-video-area').find('.video-controls')
    var $video_container = $(this).siblings('.custom-video-area')

    $video[0].pause();
    $video_controls.removeClass("playing");
    $video_container.parents(".video-header").removeClass("playing");
    $video.parents('.video_big').fadeOut();
    $('html').removeClass('open');
    $('.main-content').removeClass('video');
    $('.breadcrumb_features').removeClass('video');
    $('#shopify-section-header').removeClass('video');
});


$(".custom-video-area").each(function () {
    // Video
    var $video_container = $(this);
    var $video = $(this).find("#video-element");

    // Video Controls
    var $video_controls = $(this).find(".video-controls");
    var $button_controls = $(this).find(".bottom-wrapper");
    var $progress_bar = $(this).find(".progress-bar");
    var $progress = $(this).find(".time-bar");
    var $buffer_bar = $(this).find(".buffer-bar");
    var $play_button = $(this).find(".play-button");
    var $mute_button = $(this).find(".sound-button");

    var $volume_wrapper = $(this).find(".volume");
    var $volume_bar = $(this).find(".volume-bar");

    var $full_screen_btn = $(this).find(".btnFS");
    var $current = $(this).find(".current");
    var $duration = $(this).find(".duration");
    var $fast_fwd = $(this).find("#fastFwd");
    var $close = $(this).find(".close");

    $video.attr('loop', '')
    // Toggles play/pause for the video
    function playVideo() {
        if ($video[0].paused) {
            $video[0].play();
            $video_controls.addClass("playing")


            if ($video_container.parents(".video-header").length) {
                $video_container.parents(".video-header").addClass("playing");
            }
        } else {
            $video[0].pause();
            $video_controls.removeClass("playing");
            $video_container.parents(".video-header").removeClass("playing");
        }
    }


    function updateVolume(x, vol) {
        if (vol) {
            $percentage = vol * 100;
        } else {
            $position = x - $volume_wrapper.offset().left;
            $percentage = 100 * $position / $volume_wrapper.width();
        }

        if ($percentage > 100) {
            $percentage = 100;
        }
        if ($percentage < 0) {
            $percentage = 0;
        }

        //update volume bar and video volume
        $volume_bar.css("width", $percentage + "%");
        $video[0].volume = $percentage / 100;

        if ($video[0].volume == 0) {
            $mute_button.removeClass("sound-med").addClass("sound-muted");
        } else if ($video[0].volume > 0.5) {
            $mute_button.removeClass("sound-muted").addClass("sound-med");
        } else {
            $mute_button.removeClass("sound-muted").removeClass("sound-med");
        }
    }

    function changeSpeed() {
        if ($video[0].playbackRate === 1) {
            $video[0].playbackRate = 2;
            $fast_fwd.text("2x Speed");
        } else if ($video[0].playbackRate === 2) {
            $video[0].playbackRate = 1;
            $fast_fwd.text("1x Speed");
        }
    }

    function launchFullscreen() {
        if ($video[0].requestFullscreen) {
            $video[0].requestFullscreen();
        } else if ($video[0].mozRequestFullScreen) {
            $video[0].mozRequestFullScreen();
        } else if ($video[0].webkitRequestFullscreen) {
            $video[0].webkitRequestFullscreen();
        } else if ($video[0].msRequestFullscreen) {
            $video[0].msRequestFullscreen();
        }
    }

    function time_format(seconds) {
        var m = Math.floor(seconds / 60) < 10 ?
            "0" + Math.floor(seconds / 60) :
            Math.floor(seconds / 60);
        var s = Math.floor(seconds - m * 60) < 10 ?
            "0" + Math.floor(seconds - m * 60) :
            Math.floor(seconds - m * 60);
        return m + ":" + s;
    }

    function startBuffer() {
        $current_buffer = $video[0].buffered.end(0);
        $max_duration = $video[0].duration;
        $perc = 100 * $current_buffer / $max_duration;
        $buffer_bar.css("width", $perc + "%");

        if ($current_buffer < $max_duration) {
            setTimeout(startBuffer, 500);
        }
    }

    function updatebar(x) {
        $position = x - $progress.offset().left;
        $percentage = 100 * $position / $progress_bar.width();
        if ($percentage > 100) {
            $percentage = 100;
        }
        if ($percentage < 0) {
            $percentage = 0;
        }
        $progress.css("width", $percentage + "%");
        $video[0].currentTime = $video[0].duration * $percentage / 100;
    }

    $video.on("loadedmetadata", function () {
        $current.text(time_format(0));
        $duration.text(time_format($video[0].duration));
        updateVolume(0, 0.7);
        setTimeout(startBuffer, 150);
    });

    // Play/pause on video click
    $video.click(function () {
        playVideo();
    });

    // Video duration timer
    $video.on("timeupdate", function () {
        $current.text(time_format($video[0].currentTime));
        $duration.text(time_format($video[0].duration));
        var currentPos = $video[0].currentTime;
        var maxduration = $video[0].duration;
        var perc = 100 * $video[0].currentTime / $video[0].duration;
        $progress.css("width", perc + "%");
    });

    /* VIDEO CONTROLS
              ------------------------------------------------------- */

    // Hide button controls when video is playing
    $video_container.on("mouseleave", function () {

        $video_controls.fadeOut();
    });

    // Show button controls on hover
    $video_container.on("mouseover", function () {


        var lastTimeMouseMoved = "";

        $video_container.mousemove(function (e) {
            $video_controls.fadeIn();

            lastTimeMouseMoved = new Date().getTime();
            var t = setTimeout(function () {
                var currentTime = new Date().getTime();
                if (currentTime - lastTimeMouseMoved > 1000) {
                    $video_controls.fadeOut();

                }
            }, 3000)
        });

    });



    // Play/pause on button click
    $play_button.click(function () {
        playVideo();
    });

    // Fast Forward Button
    $fast_fwd.click(function () {
        changeSpeed();
    });

    // Volume Drag
    var volumeDrag = false;
    $volume_wrapper.on("mousedown", function (e) {
        volumeDrag = true;
        $video[0].muted = false;
        $mute_button.removeClass("muted");
        updateVolume(e.pageX);
    });

    $(document).on("mouseup", function (e) {
        if (volumeDrag) {
            volumeDrag = false;
            updateVolume(e.pageX);
        }
    });

    $(document).on("mousemove", function (e) {
        if (volumeDrag) {
            updateVolume(e.pageX);
        }
    });

    // Mute video on button click
    $mute_button.click(function () {
        $video[0].muted = !$video[0].muted;
        $(this).toggleClass("sound-muted");
        if ($video[0].muted) {
            $volume_bar.css("width", 0);
        } else {
            $volume_bar.css("width", $video[0].volume * 100 + "%");
        }
    });


    // Full Screen Button
    $full_screen_btn.click(function () {
        launchFullscreen();
    });

    // VIDEO PROGRESS BAR
    //when video timebar clicked
    var timeDrag = false; /* check for drag event */
    $progress_bar.on("mousedown ", function (e) {
        timeDrag = true;
        updatebar(e.pageX);
    });
    $(document).on("mouseup", function (e) {
        if (timeDrag) {
            timeDrag = false;
            updatebar(e.pageX);
        }
    });
    $(document).on("mousemove touchstart", function (e) {
        if (timeDrag) {
            updatebar(e.pageX);
        }
    });

});


$(window).resize(function () {
    if ($(window).width() < 1140) {

        $(function () {
            //Enable swiping...
            $("#ajaxifyModal").swipe({
                swipeStatus: function (event, phase, direction, distance, duration, fingers, fingerData, currentDirection) {

                    //       console.log(phase)
                    //       console.log(currentDirection)
                    //       console.log(direction)
                    //       console.log(distance)

                    //Here we can check the:
                    //phase : 'start', 'move', 'end', 'cancel'
                    //direction : 'left', 'right', 'up', 'down'
                    //distance : Distance finger is from initial touch point in px
                    //duration : Length of swipe in MS
                    //fingerCount : the number of fingers used

                    if (phase == "move" && direction == "right") {
                        $("#ajaxifyModal").css('transform', 'translateX(' + distance + 'px');
                        $("#ajaxifyModal").css('transition', 'none');

                    } else if (phase == "move" && direction == "left") {
                        if (direction == "left") {
                            $("#ajaxifyModal").css('transform', 'translateX(' + 0 + 'px');
                            $("#ajaxifyModal").css('transition', 'none');
                        } else if (direction == "right") {
                            $("#ajaxifyModal").css('transform', 'translateX(' + distance + 'px');
                            $("#ajaxifyModal").css('transition', 'none');
                        }

                    } else if (phase == "move" && direction == "up") {
                        $("#ajaxifyModal").css('transform', '');
                        $("#ajaxifyModal").css('transition', '');

                    } else if (phase == "move" && direction == "down") {
                        $("#ajaxifyModal").css('transform', '');
                        $("#ajaxifyModal").css('transition', '');

                    } else if (phase == "cancel") {
                        $("#ajaxifyModal").css('transform', '');
                        $("#ajaxifyModal").css('transition', '');

                    } else if (phase == "end" && direction == "right") {
                        $('#ajaxifyModal').removeClass('is-visible');
                        $('body').removeClass('ajaxify-modal--visible');
                        $("#ajaxifyModal").css('transform', '');
                        $("#ajaxifyModal").css('transition', '');

                    } else if (phase == "end" && direction == "left") {
                        $("#ajaxifyModal").css('transform', '');
                        $("#ajaxifyModal").css('transition', '');

                    } else if (phase == "end" && direction == "up") {
                        $("#ajaxifyModal").css('transform', '');
                        $("#ajaxifyModal").css('transition', '');

                    } else if (phase == "end" && direction == "down") {
                        $("#ajaxifyModal").css('transform', '');
                        $("#ajaxifyModal").css('transition', '');
                    }

                },
                allowPageScroll: $.fn.swipe.pageScroll.HORIZONTAL,
                threshold: 100,
            });
        });
    }
});